export default {
  apiKey: "AIzaSyBIgAgBJalHRXrZdfiGZdP033w2OsFXFUU",
  authDomain: "feedback.raiderarts.net",
  projectId: "raider-feedback",
  storageBucket: "raider-feedback.appspot.com",
  databaseURL: "https://raider-feedback-default-rtdb.europe-west1.firebasedatabase.app/",
  messagingSenderId: "1036137846206",
  appId: "1:1036137846206:web:a35745cbb82addced0d5ef"
};
